import { makeStyles } from '@material-ui/core/styles'
import Grid from '@mui/material/Grid'
import formatToINR, {
  formatToShortHandNotation,
} from 'src/utils/commonMethods/formatToINR'
import { Button } from '@mui/material'
import { COLORS } from 'src/utils/Themes/colors'
import DoubleArrowRoundedIcon from '@mui/icons-material/DoubleArrowRounded'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  updateLifeInsuredMemberDetails,
  updateLifeNomineeDetails,
  updateLifeProposerDetails,
  updateLifeSelectedQuickQuote,
} from 'src/actions'
import { getProposerAndInsuredMemberDetails } from 'src/services/buyPolicy'

const LifeQuickQuoteTile = ({ quoteDetails }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()

  const lifeReducerData = useSelector((state) => state?.buyPolicyLifeReducer)

  const handleBuy = () => {
    dispatch(updateLifeSelectedQuickQuote(quoteDetails))
    const { proposerDetails, insuredMemberDetails, nomineeDetails } =
      getProposerAndInsuredMemberDetails(lifeReducerData)
    dispatch(updateLifeProposerDetails(proposerDetails))
    dispatch(updateLifeInsuredMemberDetails(insuredMemberDetails))
    dispatch(updateLifeNomineeDetails(nomineeDetails))
    history.push(
      '/individual/dashboard/buyPolicy/life/insuranceDetails/member-details'
    )
  }

  return (
    <div className={classes.root}>
      <div className={classes.tileContainer}>
        <div className={classes.gridContainer}>
          <Grid container spacing={2} alignItems={'center'}>
            <Grid item xs={12} sm={12} md={4} lg={3}>
              <div className={classes.providerContainer}>
                <div className={classes.providerImageContainer}>
                  <img src={quoteDetails?.providerImage} alt='Provider' />
                </div>
                <span className={classes.providerName}>
                  {quoteDetails?.providerName}
                </span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={3}>
              <div className={classes.quoteDetails}>
                <span className={classes.label}>Claim Settled*</span>
                <span className={classes.value}>
                  {quoteDetails?.claimSettled}
                </span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={3}>
              <div className={classes.quoteDetails}>
                <span className={classes.label}>Total Cover</span>
                <span className={classes.value}>
                  {formatToShortHandNotation(quoteDetails?.sumInsured)}
                </span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={3}>
              <div className={classes.quoteDetails}>
                <Button
                  variant='contained'
                  className={classes.buyButton}
                  onClick={handleBuy}
                >
                  <span>Buy</span>
                  <DoubleArrowRoundedIcon />
                </Button>
                <span className={classes.monthlyPremiumText}>
                  {formatToINR(quoteDetails?.premiumAmount / 12)} / month
                </span>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
}

export default LifeQuickQuoteTile

export const useStyles = makeStyles({
  root: {
    background: 'linear-gradient(180deg, #B6D1D9 0%, #FFFFFF 100%)',
    padding: '1px',
    borderRadius: '11px',
  },
  tileContainer: {
    boxShadow: '0px 8px 8px 0px #0000001A',
    display: 'flex',
    borderRadius: '10px',
    backgroundColor: '#FFFFFF',
  },
  gridContainer: {
    display: 'flex',
    width: '100%',
    padding: '15px',
  },
  providerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  providerImageContainer: {
    width: '100%',
    height: '100%',
  },
  providerName: {
    fontSize: '12px',
  },
  quoteDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  label: {
    fontSize: '12px',
    color: '#4c5a6f',
  },
  value: {
    fontSize: '18px',
    fontWeight: '500',
  },
  monthlyPremiumText: {
    fontSize: '16px',
    fontWeight: '400',
  },
  buyButton: {
    backgroundColor: `${COLORS.DARK_PINK} !important`,
    color: '#ffffff !important',
    justifyContent: 'space-between !important',
    alignItems: 'center !important',
  },
})
